define(
	'Tavanoteam.TavanoTeam_Facets_Manager_Extension.FacetsManager'
	, []
	, function () {

		'use strict';

		return {

			mountToApp: function mountToApp(container) {

				var config = container.getComponent("Environment");

				var excludedFacet = config.getConfig('tavanoTeamFacetsManagerExtension.fields');

				if (excludedFacet) {

					_.extend(config.application.Configuration.searchApiMasterOptions.Facets, {
						'facet.exclude': excludedFacet.toString()
					});

					_.extend(config.application.Configuration.searchApiMasterOptions.itemsSearcher, {
						'facet.exclude': excludedFacet.toString()
					});

					_.extend(config.application.Configuration.searchApiMasterOptions.typeAhead, {
						'facet.exclude': excludedFacet.toString()
					});

					_.extend(config.application.Configuration.searchApiMasterOptions.relatedItems, {
						'facet.exclude': excludedFacet.toString()
					});

					_.extend(config.application.Configuration.searchApiMasterOptions.correlatedItems, {
						'facet.exclude': excludedFacet.toString()
					});
				}
			}
		};
	}
);
